import React from 'react'
import { useFetch } from '../../components/component-items/helpers'
// Components
import CardLoading from '../../components/component-items/loading-popover'
import { StatusBarStyled } from '../../components/component-items/status-bar'
import { globalState } from '../../store'
import { useTheme } from 'styled-components'
import { Link } from 'react-router-dom'

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarStar, faUsers, faBriefcase } from '@fortawesome/pro-duotone-svg-icons'

export const StatusBar = () => {
  const {
    state: { companyId },
  } = globalState()
  const theme: any = useTheme()
  const { response: resp, error, loaded, placeholder }: any = useFetch(`/api/company/${companyId}/`, {})
  const dateJoined = loaded
    ? new Date(resp?.created).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : ''
  const companyName = loaded ? resp?.name : ''
  const activeUserCount = loaded ? resp?.activeUserCount : 0
  return (
    <div className="row">
      <div className="col">
        <StatusBarStyled>
          <div className="header-item">
            <div className="status-icon">
              <FontAwesomeIcon icon={faUsers} style={{ color: theme.colors.freshEggplant }} />
            </div>
            <div className="status-text">
              <div>
                <Link to="/company/users/">{activeUserCount} Active Users</Link>
              </div>
            </div>
          </div>
          <div className="border-line"></div>
          <div className="header-item center">
            <div className="status-icon">
              <FontAwesomeIcon icon={faBriefcase} style={{ color: 'blue' }} />
            </div>
            <div className="status-text" style={{ fontWeight: 500 }}>
              {companyName}
            </div>
          </div>
          <div className="border-line"></div>
          <div className="header-item right">
            <div className="status-text">
              Date Joined: <strong>{dateJoined}</strong>
            </div>
            <div className="status-icon" style={{ marginLeft: '1em' }}>
              <FontAwesomeIcon icon={faCalendarStar} style={{ color: 'blue' }} />
            </div>
          </div>
          {!loaded && <CardLoading text={placeholder} error={error} />}
        </StatusBarStyled>
      </div>
    </div>
  )
}
